import enGB from 'i18n/translations/en-GB';
import { checkKeyExistsInObject } from 'utils';

// To avoid doing a big upgrade to a version of react-i18next with TFunctionKeys
// we're using any here, to keep t and Trans happy

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (key: string, path: string, parentPath?: string): any => {
  parentPath = parentPath || 'service.services';
  path = path ? `.${path}` : '';

  if (checkKeyExistsInObject(enGB, `book.${parentPath}.${key}${path}`)) {
    return `${parentPath}.${key}${path}`;
  }

  return `${parentPath}.default${path}`;
};
